import { Client } from './api';

const WorkClient = new Client(window._env_.REACT_APP_BBF_URL);

export default WorkClient;
